import React, { useEffect, useRef } from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import banner from "assets/img/new/banner.png";
import entrepreneurialfoundation from "assets/img/EntrepreneurialFoundation.webp";
import playwithpurpose from "assets/img/playwithpurpose.webp";
import technologyy from "assets/img/technologyy.webp";
import modality from "assets/img/modality.webp";
import nature from "assets/img/nature.webp";
import skill from "assets/img/skill.webp";
import freedom from "assets/img/Freedom.webp";
import bgg from "assets/img/bgg.png";
import { useLocation } from "react-router-dom";

export default function Foundation() {
  const { hash } = useLocation(); // Get the hash from the URL
  const sectionRefs = {
    entrepreneurial: useRef(null),
    playWithPurpose: useRef(null),
    toc: useRef(null),
    modality: useRef(null),
    nature: useRef(null),
    freedom: useRef(null),
    skillBased: useRef(null),
  };

  useEffect(() => {
    // Check if the hash matches the section ID and scroll to it
    if (hash === "#entrepreneurial-section" && sectionRefs.entrepreneurial.current) {
      sectionRefs.entrepreneurial.current.scrollIntoView({ behavior: "smooth" });
    }
    if (hash === "#play-with-purpose-section" && sectionRefs.playWithPurpose.current) {
      sectionRefs.playWithPurpose.current.scrollIntoView({ behavior: "smooth" });
    }
    if (hash === "#technology-of-consciousness-section" && sectionRefs.toc.current) {
      sectionRefs.toc.current.scrollIntoView({ behavior: "smooth" });
    }
    if (hash === "#modality-of-consciousness-section" && sectionRefs.modality.current) {
      sectionRefs.modality.current.scrollIntoView({ behavior: "smooth" });
    }
    if (hash === "#nature-and-environment-section" && sectionRefs.nature.current) {
      sectionRefs.nature.current.scrollIntoView({ behavior: "smooth" });
    }
    if (hash === "#freedom-to-grow-section" && sectionRefs.freedom.current) {
      sectionRefs.freedom.current.scrollIntoView({ behavior: "smooth" });
    }
    if (hash === "#skill-based-learning-section" && sectionRefs.skillBased.current) {
      sectionRefs.skillBased.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [hash]);



  return (
    <>
      <AdminNavbar />
      <section
        className=" xl:block lg:block md:block sm:hidden hidden"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${banner})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "105% auto",
        }}
      >
        <div className="text-center justify-center xl:w-11/12 lg:w-11/12 md:w-11/12 w-12/12  md:pt-24 md:pb-20 lg:pt-28 lg:pb-20 xl:pt-36 xl:pb-32 mx-auto xl:mt-0 lg:mt-0 md:mt-12">
          <h1
            className="text-black xl:text-6xl lg:text-4xl md:text-3xl font-semibold xl:pt-1 "
            style={{ lineHeight: 1.4 }}
          >
            Way Of Learning
          </h1>
        </div>
      </section>

      {/* mobilebanner */}
      <section
        className=" xl:hidden lg:hidden md:hidden sm:block block mt-18"
        style={{
          backgroundColor: "#f0f7fa",
          // backgroundImage: `url(${banner})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% auto",
        }}
      >
        <div className="text-center justify-center">
          <h1
            className="text-black text-3xl font-semibold  pt-16 pb-16"
            style={{ lineHeight: 1.4 }}
          >
            Way Of Learning
          </h1>
        </div>
      </section>

      <section className="xl:py-12 lg:py-12 md:py-12 container mx-auto parkinsans xl:px-0 lg:px-4 md:px-4 xl:block lg:block md:block sm:hidden hidden ">
        <div className="flex gap-6 ">
          <div
        id="entrepreneurial-section"
        ref={sectionRefs.entrepreneurial} className="xl:w-6/12 lg:w-6/12 md:w-12/12 ">
            <div className="flex items-center">
              <div
                className="xl:w-8/12 lg:w-8/12 md:w-10/12 md:py-12 md:px-4 lg:py-12 lg:px-6 xl:py-12 xl:px-8"
                style={{
                  background: "#FEFACF",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "55% auto",
                }}
              >
                <p
                  className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                  style={{ color: "#b6b6b6" }}
                >
                  01
                </p>
                <h1 className="text-black xl:text-3xl lg:text-2xl md:text-2xl md:pt-2 lg:pt-2 font-semibold xl:pt-3">
                  Entrepreneurial Foundation
                </h1>
                <p className="xl:pt-4 lg:pt-4 lg:w-11/12 xl:w-11/12 md:w-11/12 ">
                  Junior Toes integrates leadership, teamwork, and financial
                  literacy into early learning, preparing children for a future
                  of possibilities.
                </p>
              </div>
              <div
                className="xl:w-5/12 lg:w-5/12 md:w-5/12 bg-white rounded  xl:-ml-16 lg:-ml-8 md:-ml-8"
                style={{ border: "1px solid #ccc" }}
              >
                <img src={entrepreneurialfoundation} alt="" />
              </div>
            </div>
          </div>






          <div
        id="play-with-purpose-section"
        ref={sectionRefs.playWithPurpose} className="xl:w-6/12 lg:w-6/12 md:w-12/12">
            <div className="flex items-center">
              <div
                className="xl:w-8/12 lg:w-8/12 lg:py-12 lg:px-6 xl:py-12 xl:px-8 md:w-10/12 md:px-4 md:py-12"
                style={{
                  background: "#DADADA",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "55% auto",
                }}
              >
                <p
                  className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                  style={{ color: "#b6b6b6" }}
                >
                  02
                </p>
                <h1 className="text-black xl:text-3xl lg:text-2xl md:text-2xl md:pt-2 lg:pt-2 font-semibold xl:pt-3">
                  Play With <br></br>Purpose
                </h1>
                <p className="xl:pt-4 lg:pt-4 lg:w-11/12 lg:pb-4 xl:w-11/12 md:w-10/12 md:pb-0 xl:pb-6">
                  Our curriculum blends joyful play with purposeful activities,
                  nurturing curiosity, problem-solving, and confidence.
                </p>
              </div>
              <div
                className="xl:w-5/12 lg:w-5/12 md:w-5/12 bg-white rounded   xl:-ml-16 lg:-ml-8 md:-ml-8"
                style={{ border: "1px solid #ccc" }}
              >
                <img src={playwithpurpose} alt="" />
              </div>
            </div>
          </div>




        </div>

        <div
        id="technology-of-consciousness-section"
        ref={sectionRefs.toc} className="xl:py-12 lg:py-12 md:py-12 md:px-4 xl:px-0 lg:px-4">
          <div className="flex items-center">
            <div
              className="xl:w-8/12 lg:w-9/12 md:w-9/12 md:py-12 md:px-4 lg:py-16 lg:px-6  xl:py-24 xl:px-8"
              style={{
                background: "#F1E1C8",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                03
              </p>
              <h1 className="text-black xl:text-3xl lg:text-3xl md:text-2xl pt-2 lg:pt-2 font-semibold xl:pt-3">
                Technology of Consciousness (TOC)
              </h1>
              <h3 className="text-gray-500 xl:text-base xl:w-9/12 lg:w-9/12 md:w-10/12 lg:pt-2 font-semibold xl:pt-3">
                "When little minds engage their senses, they discover a world
                full of wonder and endless possibilities."
              </h3>
              <p className="xl:pt-4 xl:w-11/12 lg:pt-4 lg:w-11/12 md:w-11/12 text-justify ">
                At Junior Toes, we embrace the Technology of Consciousness (TOC)
                to help children connect deeply with their world by engaging all
                five senses—sight, sound, touch, taste, and smell. This
                multi-sensory approach stimulates curiosity, enhances learning,
                and develops critical thinking skills. Whether it's exploring
                textures in nature, listening to the rhythm of a story, or
                tasting new flavours, TOC transforms everyday experiences into
                powerful learning opportunities
              </p>
            </div>
            <div
              className="xl:w-4/12 lg:w-4/12  bg-white rounded  xl:-ml-16 lg:-ml-8 md:-ml-8"
              style={{ border: "1px solid #ccc" }}
            >
              <img src={technologyy} alt="" />
            </div>
          </div>
        </div>




        <div
        id="modality-of-consciousness-section"
        ref={sectionRefs.modality} className="xl:py-12 lg:py-12 md:py-12 pr-4 xl:pr-0 ">
          <div className="flex items-center">
            <div
              className="xl:w-4/12 lg:w-4/12  bg-white rounded  xl:-mr-10 lg:-mr-4 md:-mr-4 z-50"
              style={{ border: "1px solid #ccc" }}
            >
              <img src={modality} alt="" />
            </div>
            <div
              className="xl:w-8/12 lg:w-10/12  xl:py-24 md:py-8 lg:py-16 lg:px-6 lg:pl-16 xl:px-8 xl:pl-16 md:pl-8"
              style={{
                background: "#F4CDBE",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                04
              </p>
              <h1 className="text-black xl:text-3xl lg:text-2xl md:text-2xl pt-2 lg:pt-2 font-semibold xl:pt-3">
                Modality of Consciousness (MOC): A Transformative Pedagogy:
              </h1>
              <h3 className="text-gray-500 xl:text-base xl:w-9/12 lg:w-10/12 md:w-12/12 pt-2 lg:pt-2 font-semibold xl:pt-3">
                "When young minds explore multiple perspectives, they not only
                understand the world better—they learn to transform it."
              </h3>
              <p className="xl:pt-4  lg:pt-4 md:pt-4 text-justify xl:mr-0 lg:mr-0 md:mr-4">
                At Junior Toes, Modality of Consciousness is our pioneering
                approach to unlocking a child’s potential. We nurture critical
                thinking, emotional intelligence, and creativity by encouraging
                children to explore ideas through diverse
                perspectives—philosophical, scientific, cultural, artistic, and
                more. This pedagogy helps children connect deeply with their
                world, fostering a lifelong ability to think independently and
                empathetically.
              </p>
            </div>
          </div>
        </div>

        <div
         className="xl:py-12 lg:py-12 md:py-12">
          <div className="flex gap-6">
            <div id="nature-and-environment-section"
        ref={sectionRefs.nature} className="xl:w-6/12 lg:w-6/12 md:w-12/12">
              <div className="flex items-center">
                <div
                  className="xl:w-8/12 lg:w-8/12 md:w-10/12 md:px-4 md:py-12 lg:py-12 lg:px-6 xl:py-12 xl:px-8"
                  style={{
                    background: "#F2F1F0",
                    backgroundImage: `url(${bgg})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "repeat",
                    backgroundSize: "55% auto",
                  }}
                >
                  <p
                    className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                    style={{ color: "#b6b6b6" }}
                  >
                    05
                  </p>
                  <h1 className="text-black xl:text-3xl lg:text-2xl md:text-2xl lg:pt-2 pt-2 font-semibold xl:pt-3">
                    Nature and Environment Focus
                  </h1>
                  <p className="xl:pt-4 xl:w-11/12 md:w-11/12 md:pt-4 lg:pt-4 lg:w-11/12 lg:pb-4 xl:pb-6">
                    We emphasize environmental sensitivity, helping children
                    connect with nature and learn responsibility toward the
                    world around them.
                  </p>
                </div>
                <div
                  className="xl:w-5/12 lg:w-5/12 md:w-5/12 bg-white rounded  xl:-ml-16 lg:-ml-8 md:-ml-8"
                  style={{ border: "1px solid #ccc" }}
                >
                  <img src={nature} alt="" />
                </div>
              </div>
            </div>



             <div
        id="freedom-to-grow-section"
        ref={sectionRefs.freedom} className="xl:w-6/12 lg:w-6/12 md:w-12/12">
              <div className="flex items-center">
                <div
                  className="xl:w-8/12 lg:w-8/12 md:w-10/12 md:py-12 md:px-6 lg:py-12 lg:px-6  xl:py-12 xl:px-8"
                  style={{
                    background: "#fff2ef",
                    backgroundImage: `url(${bgg})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "repeat",
                    backgroundSize: "55% auto",
                  }}
                >
                  <p
                    className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                    style={{ color: "#b6b6b6" }}
                  >
                    06
                  </p>
                  <h1 className="text-black xl:text-3xl lg:text-2xl md:text-2xl lg:pt-2 pt-2 font-semibold xl:pt-3">
                    Freedom to <br></br>Grow
                  </h1>
                  <p className="xl:pt-4 xl:w-11/12 lg:pt-4 lg:w-11/12 md:w-11/12 lg:pb-4 xl:pb-6">
                    At Junior Toes, we honour each child’s individuality,
                    creating a nurturing environment where innocence,
                    exploration, and learning thrive.
                  </p>
                </div>
                <div
                  className="xl:w-5/12 lg:w-5/12 md:w-5/12 bg-white rounded  xl:-ml-16 lg:-ml-8 md:-ml-8"
                  style={{ border: "1px solid #ccc" }}
                >
                  <img src={skill} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
        id="skill-based-learning-section"
        ref={sectionRefs.skillBased} className="xl:py-12 lg:py-12 md:py-12 xl:pr-0 lg:pr-4">
          <div className="flex items-center">
            <div
              className="xl:w-8/12 lg:w-9/12 md:w-10/12 md:py-12 md:px-6 lg:py-16 lg:px-8 xl:py-24 xl:px-8"
              style={{
                background: "#e2f9fe",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" xl:text-7xl lg:text-6xl md:text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                07
              </p>
              <h1 className="text-black xl:text-3xl xl:w-0 lg:w-10/12 md:w-10/12 lg:text-2xl lg:pt-2 font-semibold xl:pt-3">
                Skill-Based Learning with an Entrepreneurial Approach
              </h1>
              <h3 className="text-gray-500 xl:text-base xl:w-9/12 lg:w-9/12 md:w-10/12 lg:pt-2 font-semibold xl:pt-3  pt-2">
                "Little learners today, big dreamers tomorrow—shaped by the
                Antah:Prerana way of learning."
              </h3>
              <p className="xl:pt-4 xl:w-11/12 lg:pt-4 lg:w-10/12 md:w-12/12">
                At Junior Toes, we integrate skill-based learning with an
                entrepreneurial approach, fostering leadership, teamwork, and
                problem-solving from an early age. This unique pedagogy,
                developed by award-winning experts at Antah:Prerana, blends
                play-based learning to nurture creativity and confidence. It
                encourages children to think independently and embrace
                challenges, preparing them for both academic and life success.
              </p>
            </div>
            <div
              className="xl:w-4/12 lg:w-4/12 md:w-4/12 bg-white rounded  xl:-ml-16 lg:-ml-8 md:-ml-8"
              style={{ border: "1px solid #ccc" }}
            >
              <img src={freedom} alt="" />
            </div>
          </div>
        </div>
      </section>

      {/* mobileview */}
      <section className="xl:hidden lg:hidden md:hidden sm:block block">


        <div
        id="entrepreneurial-section"
        ref={sectionRefs.entrepreneurial} className="px-4 mt-12">
          <div className=" ">
            <div
              className=" py-12 p-4"
              style={{
                background: "#FEFACF",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                01
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Entrepreneurial Foundation
              </h1>
              <p className="pt-4  ">
                Junior Toes integrates leadership, teamwork, and financial
                literacy into early learning, preparing children for a future of
                possibilities.
              </p>
            </div>
            <div className=" rounded flex justify-center">
              <img
                className="w-8/12 -mt-6"
                src={entrepreneurialfoundation}
                alt=""
              />
            </div>
          </div>
        </div>

        <div
        id="play-with-purpose-section"
        ref={sectionRefs.playWithPurpose} className=" px-4 mt-12">
          <div className=" ">
            <div
              className=" py-12 p-4"
              style={{
                background: "#DADADA",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold "
                style={{ color: "#b6b6b6" }}
              >
                02
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Play With Purpose
              </h1>
              <p className="pt-4  ">
                Our curriculum blends joyful play with purposeful activities,
                nurturing curiosity, problem-solving, and confidence.
              </p>
            </div>
            <div
              className=" rounded flex justify-center z-50"
              style={{ border: "1px solid #ccc" }}
            >
              <img className="w-8/12 -mt-6" src={playwithpurpose} alt="" />
            </div>
          </div>
        </div>

        <div
        id="technology-of-consciousness-section"
        ref={sectionRefs.toc} className="w-12/12 px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4"
              style={{
                background: "#F1E1C8",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                03
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Technology of Consciousness (TOC)
              </h1>
              <h3 className="text-gray-500 pt-2 font-semibold">
                "When little minds engage their senses, they discover a world
                full of wonder and endless possibilities."
              </h3>
              <p className="pt-4 text-justify ">
                At Junior Toes, we embrace the Technology of Consciousness (TOC)
                to help children connect deeply with their world by engaging all
                five senses—sight, sound, touch, taste, and smell. This
                multi-sensory approach stimulates curiosity, enhances learning,
                and develops critical thinking skills. Whether it's exploring
                textures in nature, listening to the rhythm of a story, or
                tasting new flavours, TOC transforms everyday experiences into
                powerful learning opportunities
              </p>
            </div>
            <div
              className="w-12/12 bg-white rounded "
              style={{ border: "1px solid #ccc" }}
            >
              <img src={technologyy} alt="" />
            </div>
          </div>
        </div>

        <div
        id="modality-of-consciousness-section"
        ref={sectionRefs.modality} className="w-12/12 px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4"
              style={{
                background: "#F4CDBE",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                04
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Modality of Consciousness (MOC): A Transformative Pedagogy:
              </h1>
              <h3 className="text-gray-500 pt-2 font-semibold">
                "When young minds explore multiple perspectives, they not only
                understand the world better—they learn to transform it."
              </h3>
              <p className="pt-4 text-justify ">
                At Junior Toes, Modality of Consciousness is our pioneering
                approach to unlocking a child’s potential. We nurture critical
                thinking, emotional intelligence, and creativity by encouraging
                children to explore ideas through diverse
                perspectives—philosophical, scientific, cultural, artistic, and
                more. This pedagogy helps children connect deeply with their
                world, fostering a lifelong ability to think independently and
                empathetically.
              </p>
            </div>
            <div
              className="w-12/12 bg-white rounded "
              style={{ border: "1px solid #ccc" }}
            >
              <img src={modality} alt="" />
            </div>
          </div>
        </div>

        <div
        id="nature-and-environment-section"
        ref={sectionRefs.nature} className=" px-4 mt-12">
          <div className=" ">
            <div
              className=" py-12 p-4"
              style={{
                background: "#F2F1F0",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                05
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Nature and Environment Focus
              </h1>
              <p className="pt-4 w-12/12 ">
                We emphasize environmental sensitivity, helping children connect
                with nature and learn responsibility toward the world around
                them.
              </p>
            </div>
            <div className=" rounded flex justify-center">
              <img className="w-8/12 -mt-6" src={nature} alt="" />
            </div>
          </div>
        </div>

        <div
        id="freedom-to-grow-section"
        ref={sectionRefs.freedom} className=" px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4 pl-8"
              style={{
                background: "#fff2ef",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold "
                style={{ color: "#b6b6b6" }}
              >
                06
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Freedom to Grow
              </h1>
              <p className="pt-4 w-12/12 ">
                At Junior Toes, we honour each child’s individuality, creating a
                nurturing environment where innocence, exploration, and learning
                thrive.
              </p>
            </div>
            <div className="flex justify-center rounded  z-50">
              <img className="w-8/12 -mt-6" src={skill} alt="" />
            </div>
          </div>
        </div>

        <div
        id="skill-based-learning-section"
        ref={sectionRefs.skillBased} className="w-12/12 px-4 mt-12">
          <div className=" ">
            <div
              className="w-12/12 py-12 p-4"
              style={{
                background: "#e2f9fe",
                backgroundImage: `url(${bgg})`,
                backgroundPosition: "center center",
                backgroundRepeat: "repeat",
                backgroundSize: "55% auto",
              }}
            >
              <p
                className=" text-5xl font-semibold"
                style={{ color: "#b6b6b6" }}
              >
                07
              </p>
              <h1 className="text-black text-2xl pt-2 font-semibold ">
                Skill-Based Learning with an Entrepreneurial Approach
              </h1>
              <h3 className="text-gray-500 pt-2 font-semibold">
                "Little learners today, big dreamers tomorrow—shaped by the
                Antah:Prerana way of learning."
              </h3>
              <p className="pt-4 text-justify ">
                At Junior Toes, we integrate skill-based learning with an
                entrepreneurial approach, fostering leadership, teamwork, and
                problem-solving from an early age. This unique pedagogy,
                developed by award-winning experts at Antah:Prerana, blends
                play-based learning to nurture creativity and confidence. It
                encourages children to think independently and embrace
                challenges, preparing them for both academic and life success.
              </p>
            </div>
            <div
              className="w-12/12 bg-white rounded "
              style={{ border: "1px solid #ccc" }}
            >
              <img src={freedom} alt="" />
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </>
  );
}
